(function () {
    if (environment_type === 'production') {
        const loginButtons = document.querySelectorAll("[data-layer-login]");
        const signupButtons = document.querySelectorAll("[data-layer-signup]");

        dataLayer.push({
            'event': 'autoPageview',
            'page': window.location.href,
            'title': document.title
        });

        if (loginButtons) {
            loginButtons.forEach(btn => {
                btn.addEventListener('click', () => {
                    dataLayer.push({
                        'event': 'click_button_login',
                        'button_name': btn.dataset.layerLogin,
                        'label': 'login',
                    })
                });
            })
        }

        if (signupButtons) {
            signupButtons.forEach(btn => {
                btn.addEventListener('click', () => {
                    dataLayer.push({
                        'event': 'click_button_sign_up',
                        'button_name': btn.dataset.layerSignup,
                        'label': 'sign_up'
                    })
                });
            })
        }
    }
}());
